<template>
  <div class="footer-container">
    <div v-if="helpShown" class="help-wrap footer_help">
      <router-link to="/help" class="help">
        <img src="../../assets/image/ic_income_question@2x.webp" alt="" />
        <span>{{ $t["using-help"] }}</span>
      </router-link>
    </div>
    <commitment-letter-link v-if="['2', 2].includes(role)"/>
    <div class="help-wrap">
      <router-link to="/laundering" class="help">
        <img src="../../assets/image/ic_money.png" alt="" />
        <span>{{ $t["laundering"] }}</span>
      </router-link>
    </div>
    <div class="footer">
      <img src="../../assets/image/ic_visa@2x.webp" />
      <img src="../../assets/image/ic_02@2x.webp" />
      <img src="../../assets/image/jcb.png" />
      <img src="../../assets/image/ic_03@2x.webp" />
      <img src="../../assets/image/ic_04@2x.webp" />
      <!-- <img src="../../assets/image/ic_05@2x.webp" /> -->
      <!-- <img src="../../assets/image/ic_06@2x.webp"> -->
    </div>
  </div>
</template>
<script>
import CommitmentLetterLink from '../../pages/CommitmentLetter/link.vue'

export default {
  components: {
    CommitmentLetterLink,
  },
  props: {
    helpShown: {
      type: Boolean,
      default: false,
    },
    role: {
      type: [String, Number],
      default: 1,
    },
  },
  inject: ['$t'],
}
</script>
<style lang="scss" scoped>
.footer-container {
  .help-wrap {
    text-align: center;
    margin-bottom: 0.4rem;

    .help {
      display: inline-block;
      font-size: 0.24rem;
      color: #a6b0bd;

      img {
        margin: 0 0.1rem;
        width: 0.28rem;
        height: 0.28rem;
      }

      * {
        vertical-align: middle;
      }
    }
  }

  .footer_help {
    margin-bottom: 0rem;
  }

  .footer {
    font-size: 0;
    display: flex;
    height: 0.88rem;
    padding: 0 0.1rem;
    background-color: #f5f7f9;
    align-items: center;
    justify-content: center;

    img {
      height: 0.56rem;
      margin: 0 0.1rem;
    }
  }
}
</style>
